import { SupaUser } from "types";

// The production rollout moment, which decides who must enroll a factor:
// accounts created before this instant are exempt.
export const MFA_ENROLLMENT_CUTOFF = new Date("2026-10-02T06:00:00Z");

// Phase 2 (MFA for everyone): replace the body with `return true;`. The RLS policy is
// conditional on a verified factor existing, so it needs no change when this flips.
export const isMfaEnrollmentRequiredForUser = (user: SupaUser): boolean =>
  new Date(user.created_at) >= MFA_ENROLLMENT_CUTOFF;
